import React from 'react';
interface SpreadsheetRowProps {
  rowId: number;
  month: string;
  year: number;
  gbpValue: string;
  exchangeRate: number | null;
  rateDate: string;
  runningTotalGBP: number;
  runningTotal: number;
  remainingFromTotal: number;
  onValueChange: (id: number, value: string) => void;
  loading: boolean;
}
export const SpreadsheetRow: React.FC<SpreadsheetRowProps> = ({
  rowId,
  month,
  year,
  gbpValue,
  exchangeRate,
  rateDate,
  runningTotalGBP,
  runningTotal,
  remainingFromTotal,
  onValueChange,
  loading
}) => {
  const calculateAUD = (): string => {
    if (!exchangeRate || gbpValue === '') return '-';
    const numValue = parseFloat(gbpValue);
    if (isNaN(numValue)) return 'Invalid input';
    return (numValue * exchangeRate).toFixed(2);
  };
  return <tr className="hover:bg-gray-50" data-id="element-83">
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-84">
        {month}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-85">
        {year}
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-86">
        <div className="flex items-center" data-id="element-87">
          <span className="text-gray-500 mr-2" data-id="element-88">£</span>
          <input type="text" value={gbpValue} onChange={e => onValueChange(rowId, e.target.value)} className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm p-2 border" placeholder="0.00" data-id="element-89" />
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-90">
        {loading ? <div className="animate-pulse bg-gray-200 h-6 w-20 rounded" data-id="element-91"></div> : exchangeRate ? <div className="flex flex-col" data-id="element-92">
            <span data-id="element-93">{exchangeRate.toFixed(4)}</span>
            {rateDate && <span className="text-xs text-gray-400" data-id="element-94">{rateDate}</span>}
          </div> : 'Loading...'}
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-95">
        <div className="text-sm font-medium text-gray-900 flex items-center" data-id="element-96">
          <span className="text-gray-500 mr-2" data-id="element-97">$</span>
          {loading ? <div className="animate-pulse bg-gray-200 h-6 w-24 rounded" data-id="element-98"></div> : calculateAUD()}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-99">
        <div className="text-sm font-semibold text-green-600 flex items-center" data-id="element-100">
          <span className="text-gray-500 mr-2" data-id="element-101">£</span>
          {runningTotalGBP > 0 ? runningTotalGBP.toFixed(2) : '-'}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-102">
        <div className="text-sm font-semibold text-blue-600 flex items-center" data-id="element-103">
          <span className="text-gray-500 mr-2" data-id="element-104">$</span>
          {runningTotal > 0 ? runningTotal.toFixed(2) : '-'}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-105">
        <div className={`text-sm font-semibold flex items-center ${remainingFromTotal < 0 ? 'text-red-600' : 'text-orange-600'}`} data-id="element-106">
          <span className="text-gray-500 mr-2" data-id="element-107">£</span>
          {runningTotalGBP > 0 ? remainingFromTotal.toFixed(2) : '225,000.00'}
        </div>
      </td>
    </tr>;
};